import { Alert, styled } from '@mui/material';
import { forwardRef } from 'react';
import Icon from 'shell/components/Icon';
import IconButton from 'shell/components/IconButton';

const SystemAlert = styled(Alert)(({ theme }) => {
    return {
        borderLeft: `3px solid ${theme.palette.ensightful.primary[500]}`,
        borderRadius: '4px 0 0 4px',
        marginRight: theme.spacing(-2),
        width: '350px',
        background: theme.palette.ensightful.primary[50],
        boxShadow: theme.palette.ensightful.shadows[1],
        '& .MuiAlert-action': {
            alignSelf: 'flex-start',
            paddingTop: theme.spacing(1.5),
        },
    };
});

const CustomAlert = styled(Alert)(({ theme }) => {
    return {
        borderRadius: '8px',
        boxShadow: theme.palette.ensightful.shadows[1],
        '& .MuiAlert-icon': {
            alignSelf: 'center',
            height: '20px',
            padding: 0,
        },
        '& .MuiAlert-action': {
            alignSelf: 'center',
            paddingTop: 0,
        },
    };
});

const CustomIcon = styled(Icon)(({ type, theme }) => {
    const background = {
        success: theme.palette.ensightful.success[700],
        warning: theme.palette.ensightful.warning[700],
        error: theme.palette.ensightful.error[800],
    }[type];

    return {
        borderRadius: '50%',
        padding: theme.spacing(1),
        fontSize: '1.25rem',
        background,
        color: theme.palette.ensightful.shades[0],
    };
});

export default forwardRef(({ children, onClose, ...rest }, ref) => {
    if (rest.severity === 'system') {
        return (
            <SystemAlert
                ref={ref}
                action={
                    <IconButton
                        aria-label={'dismiss message'}
                        kind={'exit'}
                        size={'small'}
                        variant={'square'}
                        onClick={onClose}
                    />
                }
                icon={false}
                {...rest}
            >
                {children}
            </SystemAlert>
        );
    }

    return (
        <CustomAlert
            ref={ref}
            action={
                <IconButton
                    aria-label={'dismiss message'}
                    kind={'exit'}
                    size={'small'}
                    variant={'square'}
                    onClick={onClose}
                />
            }
            iconMapping={{
                success: <CustomIcon kind={'checkmark'} type={'success'} />,
                warning: <CustomIcon kind={'error'} type={'warning'} />,
                error: <CustomIcon kind={'error'} type={'error'} />,
            }}
            {...rest}
        >
            {children}
        </CustomAlert>
    );
});
